import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const DownloadButton = ({ request_promise, file_name, tkey, className, disabled, style }) => {
  const { t } = useTranslation();
  const [downloading, setDownloading] = useState(false);

  const onClick = async () => {
    setDownloading(true);

    try {
      const response = await request_promise();

      const url = window.URL.createObjectURL(new Blob([response.data || response]));
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', file_name);
      document.body.appendChild(link);
      link.click();
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button type="button" onClick={onClick} className={className} disabled={disabled || downloading} style={style}>
      {downloading ? t('keys.downloading') : t(tkey)}
    </button>
  );
};

export default DownloadButton;
